export const usePantameraService = () => {
  const getCssVariable = (name: string) => {
    return getComputedStyle(document.documentElement)
      .getPropertyValue(`--${name}`)
      .trim();
  };

  return { getCssVariable };
};